module.exports = __webpack_public_path__ + "img/pl_2017.770246a0.svg";